import { Injectable } from '@angular/core';
import { GenericResponse } from '../business-entities/generic-response';
import { MechanicTimeCode, MechanicTimeCodeDetailsListViewModel } from '../business-entities/mechanic-time-code-model';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';

@Injectable({
    providedIn: 'root'
})

export class MechanicTimeCodeDataService {
    constructor(private dataProvider: DataService) {
    }

    async getMechanicTimeCodeList(DealerId:string,language): Promise<GenericResponse<MechanicTimeCodeDetailsListViewModel>> {
        return this.dataProvider.Get<GenericResponse<MechanicTimeCodeDetailsListViewModel>>(Urls.GetMechanicTimeCodeList,DealerId,language)
        .toPromise();
    }

    addMechanicTimeCodeList(model:any) : Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.AddMechanicTimeCode, model).toPromise();
    }

    async getMechanicTimeCodeById(Id: number): Promise<GenericResponse<MechanicTimeCode>> {
        return this.dataProvider.Get<GenericResponse<MechanicTimeCode>>
        (Urls.GetMechanicTimeCodeById, Id).toPromise();
    }
    editMechanicTimeCode(model:any): Promise<any> {
        return this.dataProvider.Post<GenericResponse<any>>(Urls.EditMechanicTimeCode, model).toPromise();
    }
    getTimeStampSummary(workorderNo:string):Promise<any>{
        return this.dataProvider.Get<GenericResponse<any>>(Urls.GetTimeStampSummary, workorderNo).toPromise();
    }
    updateJobStatus(model:any):Promise<any>
    {
        return this.dataProvider.Put<GenericResponse<any>>(Urls.UpdateJobStatus,model).toPromise();
    }

}